module.exports = __webpack_public_path__ + "img/login1.d6d3bb09.jpg";